import { Flex } from '../../components/UI-CHAKRA/Flex';
import { Text } from '../../components/UI-CHAKRA/Text';
import { usePrescriptionStore } from '../../stores/prescriptionStore';
import PrescriptionLayout from '../prescription/PrescriptionLayout';
import { DEFAULT_PRIMARY_COLOR } from '../prescription/usePrescription/helpers.mock';

const PrescriptionEmittedError = () => {
  const validationCode = usePrescriptionStore((store) => store.validationCode());

  return (
    <PrescriptionLayout continueButtonLabel="" onContinue={() => {}} loading={false} showMyCentral={false}>
      <Flex flexDir="column" height="100%" justifyContent="center" alignItems="center">
        <Text as="h1" fontSize="30px" fontWeight={700} color={DEFAULT_PRIMARY_COLOR}>
          Não é possível editar a receita {validationCode}.
        </Text>
        <Text as="h1" fontSize="30px" fontWeight={400} color={DEFAULT_PRIMARY_COLOR}>
          Essa receita não pode ser modificada pois já foi finalizada.
        </Text>
      </Flex>
    </PrescriptionLayout>
  );
};

export default PrescriptionEmittedError;
